import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';

export default styled.p`
  color: ${Color.BLACK_45};
  line-height: 24px;
  font-size: 16px;
`;
